import { useAuth } from '../auth/AuthContext';
import { IconLogout } from '../ui/icons';
import { ThemeToggle } from '../ui/ThemeToggle';
import { Breadcrumbs, type Crumb } from './Breadcrumbs';

export function Topbar({ crumbs }: { crumbs: Crumb[] }) {
  const { logout } = useAuth();
  return (
    <header className="flex h-[42px] items-center gap-3 border-b border-border px-5">
      <Breadcrumbs items={crumbs} />
      <div className="flex-1" />
      <div className="flex items-center gap-1">
        <ThemeToggle />
        <button
          type="button"
          onClick={logout}
          title="Выйти"
          aria-label="Выйти"
          className="inline-flex h-8 w-8 items-center justify-center rounded text-muted hover:bg-panel hover:text-fg transition-colors"
        >
          <IconLogout size={14} />
        </button>
      </div>
    </header>
  );
}
